
import { defineComponent } from 'vue'
import router from '@/router'
import Decade from '@/components/Decade.vue'
import Page from '@/components/Page.vue'
import AppHeader from '@/components/AppHeader.vue'
import Quote from '@/components/Quote.vue'
import { quotes } from '@/features/quotes'
import { useMediaQuery } from '@/composables/useMediaQuery'

export default defineComponent({
  name: 'Calendar',

  components: {
    Decade,
    Page,
    AppHeader,
    Quote
  },

  setup () {
    return {
      ...useMediaQuery()
    }
  },

  data () {
    return {
      quote: quotes[0]
    }
  },

  methods: {
    getNumOfWeeksPassed (decade: number): number {
      const birthDay = router.currentRoute.value.query.birthDay?.toString() ?? ''
      const timePassed = Date.now() - new Date(birthDay).getTime()
      const weeksPassed = Math.floor((timePassed / 1000) / 60 / 60 / 24 / 7)

      const numOfDecadesPassed = weeksPassed / 520

      if (decade > Math.ceil(numOfDecadesPassed)) {
        return 0
      }

      return Math.floor(weeksPassed / (520 * decade)) !== 0 ? 520 : weeksPassed % 520
    }
  }
})
